export default {
  sections: {
    title: {
      title: 'Commande confirmée',
      description: 'Votre carte cadeau a été achetée avec succès',
    },
    instructions: {
      title: 'Vérifiez votre e-mail',
      description:
        'Nous avons envoyé les détails de votre carte cadeau et votre reçu à votre adresse e-mail. Le code arrivera dans 5 à 10 minutes.',
    },
    details: {
      total: 'Total',
      order_number: 'Numéro de commande',
    },
    footer: {
      help: 'Notre partenaire technique Foodamigos gère les cartes cadeaux. Si vous ne la recevez pas ou ne la trouvez pas, contactez-les à {{email}}',
      questions: "Pour toute question sur l'utilisation, contactez-nous directement à {{email}}",
    },
  },
  buttons: {
    go_home: "Retour à l'accueil",
    download_pdfs: 'Télécharger le PDF de la carte cadeau',
  },
};
